import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiRefreshCw, FiInfo } from 'react-icons/fi';
import './ProfilPT.css';

const ProfilPT = () => {
  const [profilData, setProfilData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    fetchProfilPT();
  }, []);

  const fetchProfilPT = async () => {
    try {
      setLoading(true);
      const response = await axios.get('http://localhost:5000/api/neofeeder/profil-pt');
      setProfilData(response.data);
    } catch (error) {
      console.error('Error fetching profil PT:', error);
      toast.error(error.response?.data?.message || 'Gagal mengambil data profil PT');
    } finally {
      setLoading(false);
    }
  };

  const handleSync = async () => {
    try {
      setSyncing(true);
      const response = await axios.post('http://localhost:5000/api/neofeeder/sync-profil-pt');
      console.log('Sync response:', response.data);
      toast.success(response.data.message || 'Profil PT berhasil disinkronkan');
      await fetchProfilPT();
    } catch (error) {
      console.error('Error syncing profil PT:', error);
      console.error('Error response:', error.response?.data);
      toast.error(error.response?.data?.message || 'Gagal sinkronisasi profil PT');
    } finally {
      setSyncing(false);
    }
  };

  if (loading) {
    return (
      <div className="profil-pt-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Memuat data profil PT...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profil-pt-container">
      <div className="page-header">
        <div className="header-content">
          <FiInfo className="header-icon" />
          <div>
            <h1>Profil Perguruan Tinggi</h1>
            <p>Informasi lengkap tentang perguruan tinggi dari Neo Feeder</p>
          </div>
        </div>
        <button 
          className="btn-sync" 
          onClick={handleSync}
          disabled={syncing}
        >
          <FiRefreshCw className={syncing ? 'spinning' : ''} />
          {syncing ? 'Menyinkronkan...' : 'Sinkronkan Data'}
        </button>
      </div>

      {profilData ? (
        <div className="profil-content">
          {/* Informasi Umum */}
          <div className="info-card">
            <div className="card-header">
              <h2>Informasi Umum</h2>
            </div>
            <div className="info-grid">
              <div className="info-item">
                <label>Kode PT</label>
                <span>{profilData.kode_perguruan_tinggi || '-'}</span>
              </div>
              <div className="info-item">
                <label>Nama PT</label>
                <span>{profilData.nama_perguruan_tinggi || '-'}</span>
              </div>
              <div className="info-item">
                <label>Nama Singkat</label>
                <span>{profilData.nama_singkat || '-'}</span>
              </div>
              <div className="info-item">
                <label>SK Pendirian</label>
                <span>{profilData.sk_pendirian || '-'}</span>
              </div>
              <div className="info-item">
                <label>Tanggal SK Pendirian</label>
                <span>{profilData.tanggal_sk_pendirian || '-'}</span>
              </div>
              <div className="info-item">
                <label>Status PT</label>
                <span className={`badge ${profilData.status_perguruan_tinggi === 'Aktif' ? 'badge-success' : 'badge-secondary'}`}>
                  {profilData.status_perguruan_tinggi || '-'}
                </span>
              </div>
            </div>
          </div>

          {/* Kontak */}
          <div className="info-card">
            <div className="card-header">
              <h2>Informasi Kontak</h2>
            </div>
            <div className="info-grid">
              <div className="info-item">
                <label>Telepon</label>
                <span>{profilData.telepon || '-'}</span>
              </div>
              <div className="info-item">
                <label>Faksimile</label>
                <span>{profilData.faksimile || '-'}</span>
              </div>
              <div className="info-item">
                <label>Email</label>
                <span>{profilData.email || '-'}</span>
              </div>
              <div className="info-item">
                <label>Website</label>
                <span>
                  {profilData.website ? (
                    <a href={profilData.website} target="_blank" rel="noopener noreferrer">
                      {profilData.website}
                    </a>
                  ) : '-'}
                </span>
              </div>
            </div>
          </div>

          {/* Alamat */}
          <div className="info-card">
            <div className="card-header">
              <h2>Alamat</h2>
            </div>
            <div className="info-grid">
              <div className="info-item full-width">
                <label>Jalan</label>
                <span>{profilData.jalan || '-'}</span>
              </div>
              <div className="info-item">
                <label>Kelurahan</label>
                <span>{profilData.nama_kelurahan || '-'}</span>
              </div>
              <div className="info-item">
                <label>Kecamatan</label>
                <span>{profilData.nama_kecamatan || '-'}</span>
              </div>
              <div className="info-item">
                <label>Kota/Kabupaten</label>
                <span>{profilData.nama_wilayah || '-'}</span>
              </div>
              <div className="info-item">
                <label>Provinsi</label>
                <span>{profilData.nama_provinsi || '-'}</span>
              </div>
              <div className="info-item">
                <label>Kode Pos</label>
                <span>{profilData.kode_pos || '-'}</span>
              </div>
            </div>
          </div>

          {/* Akreditasi */}
          <div className="info-card">
            <div className="card-header">
              <h2>Akreditasi</h2>
            </div>
            <div className="info-grid">
              <div className="info-item">
                <label>Peringkat Akreditasi</label>
                <span className="badge badge-primary">
                  {profilData.peringkat_akreditasi || '-'}
                </span>
              </div>
              <div className="info-item">
                <label>SK Akreditasi</label>
                <span>{profilData.sk_akreditasi || '-'}</span>
              </div>
              <div className="info-item">
                <label>Tanggal SK Akreditasi</label>
                <span>{profilData.tanggal_sk_akreditasi || '-'}</span>
              </div>
              <div className="info-item">
                <label>Tanggal Berakhir Akreditasi</label>
                <span>{profilData.tanggal_berakhir_akreditasi || '-'}</span>
              </div>
            </div>
          </div>

          {/* Informasi Lainnya */}
          <div className="info-card">
            <div className="card-header">
              <h2>Informasi Lainnya</h2>
            </div>
            <div className="info-grid">
              <div className="info-item">
                <label>Bentuk PT</label>
                <span>{profilData.nama_bentuk_pendidikan || '-'}</span>
              </div>
              <div className="info-item">
                <label>Kategori PT</label>
                <span>{profilData.nama_kategori_perguruan_tinggi || '-'}</span>
              </div>
              <div className="info-item">
                <label>Tanggal Berdiri</label>
                <span>{profilData.tanggal_berdiri || '-'}</span>
              </div>
              <div className="info-item">
                <label>NPSN</label>
                <span>{profilData.npsn || '-'}</span>
              </div>
              <div className="info-item">
                <label>Luas Tanah (m²)</label>
                <span>{profilData.luas_tanah_milik || '-'}</span>
              </div>
              <div className="info-item">
                <label>Luas Bangunan (m²)</label>
                <span>{profilData.luas_tanah_bukan_milik || '-'}</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="empty-state">
          <FiInfo size={64} />
          <h3>Data Profil PT Tidak Tersedia</h3>
          <p>Klik tombol "Sinkronkan Data" untuk mengambil data dari Neo Feeder</p>
          <button className="btn-sync" onClick={handleSync} disabled={syncing}>
            <FiRefreshCw className={syncing ? 'spinning' : ''} />
            {syncing ? 'Menyinkronkan...' : 'Sinkronkan Data'}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfilPT;
